<template>
  <div class="validate-input-container pb-3">
    <input
      v-if="tag !== 'textarea'"
      class="form-control"
      :class="{'is-invalid':inputRef.error}"
      aria-describedby="emailHelp"
      @blur="validateInput"
      v-model = "inputRef.val"
      v-bind="$attrs"
    />
    <textarea
      v-else
      class="form-control"
      :class="{'is-invalid':inputRef.error}"
      aria-describedby="emailHelp"
      @blur="validateInput"
      v-model = "inputRef.val"

      v-bind="$attrs"
    />
    <div v-if="inputRef.error" class="invalid-feedback">{{inputRef.message}}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, PropType, onMounted, computed} from "vue";
import {emitter} from './ValidateForm.vue'

const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const passwordReg = /^[a-zA-Z0-9]{6,12}$/


interface RuleProp {
  type: 'required' | 'email' | 'custom';
  message: string;
  validator?: () => boolean;
}
export type RulesProp = RuleProp[]
export type tagType = 'input'|'textarea'
export default defineComponent({
  props: {
    rules: Array as PropType<RulesProp>,
    modelValue: String,
    tag:{
      type: String as PropType<tagType>,
      default: 'input'
    }
  },
  inheritAttrs: false,
  setup(props, context){
    const inputRef = reactive({
      // val: props.modelValue || '',
      val:computed({
        get: () => props.modelValue || '',
        set: val => {
          context.emit('update: modelvalue', val)
        }
      }),
      error: false,
      message: ''
    })
    const updateValue = (e:Event) => {
      const targetValue = (e.target as HTMLInputElement).value
      inputRef.val = targetValue
      context.emit('update:modelValue', targetValue)
    }
    const validateInput = () => {
      if (props.rules){
        const allPassed = props.rules.every(rule => {
          let passed = true
          inputRef.message = rule.message
          switch (rule.type){
            case 'required':
              passed = (inputRef.val.trim() !== '')
              break
            case 'email':
              passed = emailReg.test(inputRef.val)
              break
            // case 'password':
            //   passed = passwordReg.test(inputRef.val)
            //   break
            case 'custom':
              passed = rule.validator ? rule.validator() : true
              break
            default:
              break
          }
          return passed
        })
        inputRef.error = !allPassed
        return allPassed
      }
      return true
    }
    onMounted(()=>{
      emitter.emit('form-item-created', validateInput)
    })
    return {
      inputRef,
      validateInput,
      updateValue
    }
  }
})
</script>

<style>

</style>